"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSelect = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _searchIcon = _interopRequireDefault(require("../../../assets/images/customSelect/searchIcon.png"));

var _customHooks = require("../../../global-files/customHooks");

var _Calendar = require("../../organisms/Calendar");

var _CustomSelectItem = require("../../atoms/CustomSelectItem");

var _jsxRuntime = require("react/jsx-runtime");

var CustomSelect = function CustomSelect(_ref) {
  var options = _ref.options,
      showSearchBar = _ref.showSearchBar,
      _ref$placeHolder = _ref.placeHolder,
      placeHolder = _ref$placeHolder === void 0 ? "Buscar departamento" : _ref$placeHolder,
      _ref$selectLabel = _ref.selectLabel,
      selectLabel = _ref$selectLabel === void 0 ? "" : _ref$selectLabel,
      _ref$customSelectId = _ref.customSelectId,
      customSelectId = _ref$customSelectId === void 0 ? "defaultSelectId" : _ref$customSelectId,
      defaultOption = _ref.defaultOption,
      parameterArray = _ref.parameterArray,
      setParameterArray = _ref.setParameterArray,
      onClickItem = _ref.onClickItem,
      icon = _ref.icon,
      customOptions = _ref.customOptions,
      _ref$isSingleSelect = _ref.isSingleSelect,
      isSingleSelect = _ref$isSingleSelect === void 0 ? false : _ref$isSingleSelect;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)(customSelectId),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showList = _useCloseModal2[0],
      setShowList = _useCloseModal2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      text = _useState4[0],
      setText = _useState4[1];

  var _useCloseModal3 = (0, _customHooks.useCloseModal)(customSelectId),
      _useCloseModal4 = (0, _slicedToArray2.default)(_useCloseModal3, 2),
      showDatePicker = _useCloseModal4[0],
      setShowDatePicker = _useCloseModal4[1];

  var _useState5 = (0, _react.useState)(new Date()),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      startDate = _useState6[0],
      setStartDate = _useState6[1];

  var _useState7 = (0, _react.useState)(new Date()),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      endDate = _useState8[0],
      setEndDate = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      activeFilters = _useState10[0],
      setActiveFilters = _useState10[1];

  var _useState11 = (0, _react.useState)(selectLabel),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      filtersString = _useState12[0],
      setFiltersString = _useState12[1];

  var _useState13 = (0, _react.useState)(0),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      filtersCounter = _useState14[0],
      setFiltersCounter = _useState14[1];

  var onChange = function onChange(evt) {
    setText(evt.target.value);
  };

  (0, _react.useEffect)(function () {
    var today = new Date();
    var diff = today.getDate() - today.getDay();
    var start = new Date(today.setDate(diff));
    var end = new Date();
    setStartDate(start);
    setEndDate(end);
    var obj = {};
    options.forEach(function (o) {
      var name = o.name,
          isSelected = o.isSelected,
          subOptions = o.subOptions;
      if (isSelected) obj[name] = {};
      subOptions === null || subOptions === void 0 ? void 0 : subOptions.forEach(function (so) {
        var nameSO = so.name,
            isSelectedSO = so.isSelected;

        if (isSelectedSO) {
          if (!obj[name]) obj[name] = {};
          obj[name][nameSO] = true;
        }
      });
    });
    setActiveFilters(obj);
    setFilters(options);
  }, [options]);

  var onChangeDatePicker = function onChangeDatePicker(dates) {
    var _dates = (0, _slicedToArray2.default)(dates, 2),
        start = _dates[0],
        end = _dates[1];

    setStartDate(start);
    setEndDate(end);
    if (end) setParameterArray(function (current) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, current), {}, {
        startDate: "".concat(start.getFullYear(), "-").concat(start.getMonth() + 1, "-").concat(start.getDate()),
        endDate: "".concat(end.getFullYear(), "-").concat(end.getMonth() + 1, "-").concat(end.getDate())
      });
    });
  };

  (0, _react.useEffect)(function () {
    var filteredArray = (options === null || options === void 0 ? void 0 : options.slice()) || [];

    if (text.length > 0) {
      filteredArray = filteredArray.filter(function (option) {
        return option === null || option === void 0 ? void 0 : option.name.toLowerCase().includes(text.toLocaleLowerCase());
      });
    }

    setFilters(filteredArray);
  }, [text]);
  (0, _react.useEffect)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var newFiltersString, counter, filtersArray;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            newFiltersString = selectLabel;
            counter = 0;
            filtersArray = Object.keys(activeFilters);
            filtersArray.length && filtersArray.forEach(function (key, index) {
              if (index === 0) newFiltersString = key;else {
                counter++;
              }
            });
            setFiltersCounter(counter);
            setFiltersString(newFiltersString);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [activeFilters]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: customSelectId,
    selectLabel: selectLabel,
    filterActive: Object.keys(activeFilters).length > 0 || customSelectId === "dates-select" && filtersString !== "Todo el tiempo",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "button-list",
      onClick: function onClick() {
        return setShowList(!showList);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        children: [filtersString, " "]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: filtersCounter > 0 && "+".concat(filtersCounter)
      }), icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: icon,
        alt: "Favorite",
        width: "20px"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "arrow-item",
        children: "\u25C0"
      })]
    }), showList && (customOptions ? customOptions : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "select-container",
      children: [showSearchBar && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "search-bar-filter",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _searchIcon.default,
          alt: "search icon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          type: "text",
          placeholder: placeHolder,
          value: text,
          onChange: onChange
        })]
      }), defaultOption && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "default-option",
        onClick: function onClick() {
          setParameterArray && setParameterArray([]);
          setActiveFilters({});
          setShowList(false);
          setFiltersString(selectLabel);
          setFiltersCounter(0);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: defaultOption
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "filters-container",
        children: filters === null || filters === void 0 ? void 0 : filters.map(function (option) {
          return isSingleSelect ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "dates-select-item",
            onClick: function onClick() {
              option.function ? option.function(setShowDatePicker) : setShowDatePicker(true);
              setFiltersString(option.name);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              children: option.name
            })
          }, customSelectId + option.id) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomSelectItem.CustomSelectItem, {
            className: "main-option",
            option: option,
            customSelectId: customSelectId,
            setParameterArray: setParameterArray,
            activeFilters: activeFilters,
            globalFilters: activeFilters,
            parameterArray: parameterArray,
            setActiveFilters: setActiveFilters,
            onClickItem: onClickItem,
            route: option.name
          }, customSelectId + option.id);
        })
      })]
    })), showDatePicker && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.Calendar, {
      onChange: onChangeDatePicker,
      startDate: startDate,
      endDate: endDate
    })]
  });
};

exports.CustomSelect = CustomSelect;